import { FC } from 'react'

import { approveAdGitOpsRequest } from '../../../api/active-directory/adGitOpsCallbacks'
import AuthenticatedAdGitOpsCallbackPage from '../callback/AuthenticatedAdGitOpsCallbackPage'

const AdGitOpsApprovalCallback: FC = () => (
	<AuthenticatedAdGitOpsCallbackPage
		title="Active Directory Approval"
		description="Your approval request is being verified with your SSP session."
		onConfirm={approveAdGitOpsRequest}
	/>
)

export default AdGitOpsApprovalCallback
